import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './components/button/button.component';
import { DataTableComponent } from './components/data-table/data-table.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list'
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { LoaderComponent } from './components/loader/loader.component';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatSliderModule } from '@angular/material/slider';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { RouterModule } from '@angular/router';
import { GenericDialogComponent } from './generic-dialog/generic-dialog.component';
import { AuthenticationComponent } from './authentication/authentication.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { WorkAreaContainerComponent } from './components/work-area-container/work-area-container.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { CircularLoaderComponent } from './components/circular-loader/circular-loader.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InputMaxLenghtDirective } from './directives/input-max-lenght.directive';
import { HasPermissionDirective } from './directives/has-permission.directive';
import { HasPermissionPipe } from './pipes/has-permission.pipe';
import { ShowWhenDirective } from './directives/show-when.directive';




@NgModule({
  declarations: [
    ButtonComponent,
    DataTableComponent,
    SidenavComponent,
    GenericDialogComponent,
    AuthenticationComponent,
    LoaderComponent,
    ErrorMessageComponent,
    WorkAreaContainerComponent,
    ResetPasswordComponent,
    CircularLoaderComponent,
    InputMaxLenghtDirective,
    HasPermissionDirective,
    HasPermissionPipe,
    ShowWhenDirective
  ],
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    NgbModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    RouterModule,
    MatDialogModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatMenuModule,
    FormsModule,
    MatSliderModule,
    MatSelectModule
  ],
  exports: [
    ButtonComponent,
    DataTableComponent,
    SidenavComponent,
    LoaderComponent,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    ErrorMessageComponent,
    AuthenticationComponent,
    WorkAreaContainerComponent,
    InputMaxLenghtDirective,
    HasPermissionDirective,
    HasPermissionPipe,
    ShowWhenDirective
  ]
})
export class SharedModule { }
